/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
/* eslint-disable no-unused-vars*/
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar, Input,
    ModalProgressBar, Select,
} from '../../../../_metronic/_partials/controls';
import { ToastContainer, toast } from 'react-toastify';
import { copyValue, currencyFormatter, toastOption } from '../../../../_metronic/_helpers';
import DonaturEditForm from './DonaturEditForm';
import DonaturTrx from '../donatur-trx/DonaturTrx';
import { DonaturTrxUIProvider } from '../donatur-trx/DonaturTrxUIContext';
import {
    greetingValue,
    initDonatur,
    initDonaturProfile,
    initLetter,
    isActive,
    isAlive,
    type,
    initUpdateBranch,
    initDonaturPassword
} from '../DonaturUIHelpers'
import * as actions from '../../Donatur/_redux/donatur/donaturAction';
import { DonaturProfileForm } from '../donatur-profile/DonaturProfileForm';
import { DonaturType } from '../donatur-type/DonaturType';
import { DonaturTypeDialog } from '../donatur-type/donatur-type-dialog/DonaturTypeDialog';
import DonaturParentTable from "../donatur-parent-table/DonaturParentTable";
import { DonaturChangePassword } from '../donatur-change-password/DonaturChangePassword';
import { DonaturMergeDonation } from '../donatur-merge-donation/DonaturMergeDonation';
import { Field, Form, Formik } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { getBranchAll } from '../../MasterData/_redux/branchs/branchCrud'
import { addParent, updateBranch } from '../_redux/donatur/donaturCrud'
import { BlockOrg, RoleChecker } from '../../../RoleChecker';
import { DonaturContributionReport } from './DonaturContributionReport';

export const DonaturEdit = ({
    history,
    match: {
        params: { id, parent_uuid, donatur_type },
    },
}) => {
    const { user } = useSelector(
        (state) => ({ user: state.auth.user }),
        shallowEqual,
    );


    const backToList = () => {
        history.push(`/donatur`);
    };
    const backToParent = () => {
        history.push(`/donatur/${parent_uuid}/edit`)
    }
    const openDetailDonationPage = (id) => {
        history.push(`/donasi/${id}/detail`);
    }
    // Tabs
    const [tab, setTab] = useState('basic');
    const [title, setTitle] = useState('');
    const [donaturProfile, setDonaturProfile] = useState([])
    const [isShow, setIsShow] = useState(false)
    const cabangRole = ['SuperAdmin', 'DataProses', 'AdminCabang', 'SuperDuperAdmin']
    const [showCabang, setShowCabang] = useState(false)
    const [branchList, setBranchList] = useState([])

    const dispatch = useDispatch();

    const { actionsLoading, donaturForEdit, error, isLetter } = useSelector((state) => ({
        actionsLoading: state.donaturs.actionsLoading,
        donaturForEdit: state.donaturs.donaturForEdit,
        isLetter: state.donaturs.is_letter,
        error: state.donaturs.error
    }),
        shallowEqual,
    );

    const fetchBranch = async (value) => {
        const result = await getBranchAll()
        setBranchList(result.data.data)
    }

    if (error) {
        toast.error(error, toastOption)
        if (id) {
            history.push(`/donatur/${id}/edit`)

        } else {
            history.push(`/donatur/new`)
        }
        // backToList();
    }

    useEffect(() => {
        dispatch(actions.fetchDonatur(id))
        fetchBranch()
    }, [id, dispatch]);

    useEffect(() => {
        let _title = id ? '' : 'Donatur Baru';
        if (donaturForEdit && id && donaturForEdit.donor_id) {
            _title = `Edit Donatur ${donaturForEdit.name} - ${donaturForEdit.donor_id}`;
        }
        if (donaturForEdit && id && !donaturForEdit.donor_id) {
            _title = `Edit Donatur ${donaturForEdit.name}`;
        }
        if (parent_uuid && !id) {
            _title = `Member Donatur Baru`;
        }
        setTitle(_title);

        if (cabangRole.includes(user.role) ||
            (user.role === 'AdminCabang' && user.channel.branch_uuid === donaturForEdit.branch_uuid)) {
            setShowCabang(true)
        }
        // donaturForEdit && setTab('riwayat_donasi')


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [donaturForEdit, id]);

    const saveDonatur = (values) => {
        // Menggunakan copy value karna values tidak bisa assign data baru didalamnya
        let data = copyValue(values)
        parent_uuid ? data.parent_uuid = copyValue(parent_uuid) : data.parent_uuid = ''

        if (!id) {
            dispatch(actions.createDonatur(data)).then(response => {
                if (response.parent_uuid) {
                    toast.success(response.message, toastOption);
                    backToParent()
                } else {
                    toast.success(response.message, toastOption);
                    backToList();
                }
            })
        } else {
            //DELETE OBJECT KEY JAVASCRIPT
            const filterValue = Object.fromEntries(
                Object.entries(data).filter(([key, value]) => key !== 'json_profile'))
            dispatch(actions.updateDonatur(filterValue)).then(response => {
                if (response) {
                    toast.success(response.message, toastOption);
                    backToList();
                }
            });
        }
    };

    const saveDonaturProfile = (values) => {
        if (id) {
            const profileJson = JSON.stringify(values);
            const profileUpdate = {
                uuid: id,
                json_profile: profileJson
            }
            dispatch(actions.updateDonatur(profileUpdate))
                .then(response => {
                    toast.success(response.message, toastOption);
                    backToList();
                })
                .catch(error => {
                    backToList();
                })
        }
    };
    const saveDonaturPassword = (values) => {
        const passwordUpdate = {
            donor_uuid: id,
            password: values.password
        }
        if (id) {
            dispatch(actions.changePasswordDonatur(passwordUpdate))
                .then(response => {
                    toast.success(response.message, toastOption);
                    backToList();
                })
                .catch(error => {
                    backToList();
                })
        }
    };
    // s2-266 fix update branch pada user tidak bisa dilakukan
    const updateDonaturBranch = async (value) => {

        if (donaturForEdit.branch_uuid && value.branch_uuid) {
            const data = {
                donor_uuid: donaturForEdit.uuid,
                branch_uuid: value.branch_uuid
            }
            await updateBranch(data).then(response => {
                toast.success(response.data.message, toastOption)
                backToList()
            }).catch(error => {
                toast.error(error.response.message, toastOption)
            })
        }

        // console.log(value)

    }

    const addDonaturChild = () => {
        setTab('basic')
        history.push(`/donatur/${donaturForEdit.uuid}/${donaturForEdit.type}`);
    }

    const openDialog = () => {
        setIsShow(true)
    }

    const closeDialog = () => {
        setIsShow(false)
    }

    const btnRef = useRef();
    const saveDonaturClick = () => {
        if (btnRef && btnRef.current) {
            btnRef.current.click();
        }
    };

    return (
        <>
            {/*<ToastContainer/>*/}
            <Card>
                {actionsLoading && <ModalProgressBar />}
                <CardHeader title={title}>
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={parent_uuid ? backToParent : backToList}
                        >
                            <i className="fa fa-arrow-left"></i>
                            Back
                        </button>
                        {`  `}
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <ul className="nav nav-tabs nav-tabs-line " role="tablist">
                        <li className="nav-item" onClick={() => setTab('basic')}>
                            <a
                                className={`nav-link ${tab === 'basic' && 'active'}`}
                                data-toggle="tab"
                                role="tab"
                                aria-selected={(tab === 'basic').toString()}
                            >
                                Info Dasar
                            </a>
                        </li>
                        {id && (
                            <li className="nav-item" onClick={() => setTab('profile')}>
                                <a
                                    className={`nav-link ${tab === 'profile' && 'active'}`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-selected={(tab === 'profile').toString()}
                                >
                                    Profil Donatur
                                </a>
                            </li>
                        )}

                        {/* {RoleChecker("Ganti Password Donatur", "detail_donatur") && id && (
                            <li className="nav-item" onClick={() => setTab('changePass')}>
                                <a
                                    className={`nav-link ${tab === 'changePass' && 'active'}`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-selected={(tab === 'changePass').toString()}
                                >
                                    Ganti Password
                                </a>
                            </li>
                        )} */}
                        {RoleChecker("Penggabungan Donasi", "detail_donatur") && id && (
                            <li className="nav-item" onClick={() => setTab('merge_donation')}>
                                <a
                                    className={`nav-link ${tab === 'merge_donation' && 'active'}`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-selected={(tab === 'migrate_donation').toString()}
                                >
                                    Penggabungan Donasi
                                </a>
                            </li>
                        )}

                        {id && (
                            <>
                                {/*add Space*/'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}
                                <li className="nav-item" onClick={() => setTab('riwayat_donasi')}>
                                    <a
                                        className={`nav-link ${tab === 'riwayat_donasi' && 'active'}`}
                                        data-toggle="tab"
                                        role="button"
                                        aria-selected={(tab === 'riwayat_donasi').toString()}
                                    >
                                        Riwayat Donasi
                                    </a>
                                </li>
                            </>
                        )}

                        {id && (
                            <>
                                {/* <li className="nav-item" onClick={() => setTab('cetak_konsolidasi')}>
                                    <a
                                        className={`nav-link ${tab === 'cetak_konsolidasi' && 'active'}`}
                                        data-toggle="tab"
                                        role="button"
                                        aria-selected={(tab === 'cetak_konsolidasi').toString()}
                                    >
                                        Cetak Konsolidasi
                                    </a>
                                </li> */}
                            </>
                        )}
                        {id && (donaturForEdit && donaturForEdit.type !== 'INDIVIDU' && !donaturForEdit.parent_uuid) && (
                            <>
                                {/*add Space*/'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}
                                <li className="nav-item" onClick={() => setTab('riwayat_donasi_child')}>
                                    <a
                                        className={`nav-link ${tab === 'riwayat_donasi_child' && 'active'}`}
                                        data-toggle="tab"
                                        role="button"
                                        aria-selected={(tab === 'riwayat_donasi_child').toString()}
                                    >
                                        Riwayat Donasi Anggota
                                    </a>
                                </li>
                            </>
                        )}

                        {id && (donaturForEdit && donaturForEdit.type !== 'INDIVIDU' && !donaturForEdit.parent_uuid) && (
                            <>
                                {/*add Space*/'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}
                                <li className="nav-item" onClick={() => setTab('komunitas')}>
                                    <a
                                        className={`nav-link ${tab === 'komunitas' && 'active'}`}
                                        data-toggle="tab"
                                        role="button"
                                        aria-selected={(tab === 'komunitas').toString()}
                                    >
                                        {donaturForEdit.type === 'LEMBAGA' && 'Daftar Lembaga'}
                                        {donaturForEdit.type === 'KOMUNITAS' && 'Daftar Komunitas'}
                                    </a>
                                </li>
                            </>
                        )}

                        {id && (donaturForEdit && donaturForEdit.type === 'INDIVIDU') && (
                            <>
                                {/*add Space*/'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}
                                <li className="nav-item" onClick={() => setTab('parent_list')}>
                                    <a
                                        className={`nav-link ${tab === 'parent_list' && 'active'}`}
                                        data-toggle="tab"
                                        role="button"
                                        aria-selected={(tab === 'parent_list').toString()}
                                    >
                                        Daftar Kelompok
                                    </a>
                                </li>
                            </>
                        )}

                        {/*PINDAH BRANCH*/}
                        {/* {showCabang && id && (
                            <li className="nav-item" onClick={() => setTab('cabang')}>
                                <a
                                    className={`nav-link ${tab === 'cabang' && 'active'}`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-selected={(tab === 'cabang').toString()}
                                >
                                    Cabang
                                </a>
                            </li>
                        )} */}
                        {donaturForEdit && (
                            <li className="nav-item" onClick={() => setTab('contribution')}>
                                <a
                                    className={`nav-link ${tab === 'contribution' && 'active'}`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-selected={(tab === 'contribution').toString()}
                                >
                                    Fund Tracker
                                </a>
                            </li>
                        )}

                    </ul>

                    <div className="mt-5">
                        {tab === 'basic' && (
                            <DonaturEditForm
                                donatur={donaturForEdit || initDonatur}
                                btnRef={btnRef}
                                saveDonatur={saveDonatur}
                                parent_uuid={parent_uuid}
                            />
                        )}
                        {tab === 'profile' && id && (
                            <DonaturProfileForm
                                donaturProfile={donaturForEdit.json_profile || initDonaturProfile}
                                btnRef={btnRef}
                                saveDonaturProfile={saveDonaturProfile}
                            />
                        )}
                        {tab === 'changePass' && id && (
                            <DonaturChangePassword
                                donaturPassword={initDonaturPassword}
                                btnRef={btnRef}
                                saveDonaturPassword={saveDonaturPassword}
                            />
                        )}

                        {tab === 'merge_donation' && id && (
                            <DonaturMergeDonation
                                donatur={donaturForEdit}
                                openDetailDonationPage={openDetailDonationPage}
                                tab={tab}
                                actionsLoading={actionsLoading}
                            />
                        )}
                        {tab === 'riwayat_donasi' && id && (
                            <DonaturTrxUIProvider donaturUuid={id}>
                                <Card>
                                    <CardBody>
                                        <DonaturTrx openDetailDonationPage={openDetailDonationPage} donaturType={donaturForEdit.type} user_uuid={id} tab={tab} pageType="riwayat" />
                                    </CardBody>
                                </Card>
                            </DonaturTrxUIProvider>
                        )}

                        {/* {tab === 'cetak_konsolidasi' && id && (
                            <DonaturTrxUIProvider donaturUuid={id}>
                                <Card>
                                    <CardBody>
                                        <DonaturTrx openDetailDonationPage={openDetailDonationPage} donaturType={donaturForEdit.type} user_uuid={id} tab={tab} pageType="konsolidasi" />
                                    </CardBody>
                                </Card>
                            </DonaturTrxUIProvider>
                        )} */}

                        {tab === 'riwayat_donasi_child' && id && (
                            <DonaturTrxUIProvider donaturUuid={id}>
                                <Card>
                                    <CardBody>
                                        <DonaturTrx openDetailDonationPage={openDetailDonationPage} donaturType={donaturForEdit.type} user_uuid={id} tab={tab} />
                                    </CardBody>
                                </Card>
                            </DonaturTrxUIProvider>
                        )}
                        {tab === 'komunitas' && id && (
                            <>
                                <Card>
                                    <CardHeader>
                                        <CardHeaderToolbar>
                                            <button
                                                type="button"
                                                className="btn btn-primary ml-2"
                                                onClick={addDonaturChild}
                                            >
                                                Buat Donatur Baru
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-outline-primary ml-2"
                                                onClick={openDialog}
                                            >
                                                Tambah Anggota
                                            </button>
                                        </CardHeaderToolbar>
                                    </CardHeader>
                                    <CardBody>
                                        <DonaturTypeDialog
                                            parent={donaturForEdit || undefined}
                                            show={isShow}
                                            onHide={closeDialog}
                                        />
                                        <DonaturType
                                            parent_uuid={donaturForEdit.parent_uuid || donaturForEdit.uuid}
                                        />
                                    </CardBody>
                                </Card>
                            </>
                        )}
                        {tab === 'parent_list' && id && (
                            <Card>
                                <CardBody>
                                    <DonaturParentTable
                                        uuid={donaturForEdit.uuid}
                                    />
                                </CardBody>
                            </Card>
                        )}

                        {tab === 'cabang' && id && (
                            <>
                                <Card>
                                    <CardBody>
                                        <h4>Donatur ini berada di
                                            cabang <b>{donaturForEdit && donaturForEdit.branch_uuid && donaturForEdit.branch.name}</b>
                                        </h4>
                                        <p>Silahkan ubah kolom dibawah jika ingin pindah cabang</p>
                                        <Formik
                                            enableReinitialize={true}
                                            initialValues={({ branch_uuid: donaturForEdit.branch_uuid }) || initUpdateBranch}
                                            onSubmit={(values) => {
                                                updateDonaturBranch(values);
                                            }}>
                                            {({ handleSubmit, handleChange, setFieldValue, values, handleBlur }) => (
                                                <>
                                                    <Form className="form form-label-right">
                                                        <div className="form-group row">
                                                            {/* <div className="col-lg-3">
                                                                <select
                                                                    className="form-control"
                                                                    name="branch_uuid"
                                                                    defaultValue={values.branch_uuid}
                                                                    onChange={(e) => {
                                                                        setFieldValue('branch_uuid', e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="">ALL</option>
                                                                    {branchList.map(value =>
                                                                        <option key={value.uuid}
                                                                            value={value.uuid}>{value.name}</option>
                                                                    )}
                                                                </select>

                                                            </div> */}
                                                        </div>
                                                        <button
                                                            type="submit"
                                                            style={{ display: 'none' }}
                                                            ref={btnRef}
                                                            onSubmit={() => handleSubmit()}
                                                        ></button>
                                                    </Form>
                                                </>
                                            )}

                                        </Formik>
                                    </CardBody>
                                </Card>

                            </>
                        )}

                        {tab === 'contribution' && id && (
                            <DonaturContributionReport donor={donaturForEdit} />
                        )}

                    </div>
                </CardBody>
                <CardBody>
                    <CardHeaderToolbar>
                        {BlockOrg() && (
                            <>
                                {tab !== 'komunitas' && tab !== "merge_donation" && (
                                    <button
                                        type="submit"
                                        className="btn btn-primary ml-2 float-right"
                                        onClick={saveDonaturClick}
                                    >
                                        Save
                                    </button>
                                )}
                            </>
                        )}
                    </CardHeaderToolbar>
                </CardBody>
            </Card>
        </>

    );
}
    ;